import { IoIosArrowRoundBack } from "react-icons/io";
import {
  Animatespin,
  SearchbarCom,
  FavJobTable,
  SidenavbarCom,
  Pagination,
} from "../../components/index";
import Functions from "./index.function";
export default function FavouritesJobs() {
  const {
    loadingapplyapi,
    showPopup,
    currentPage,
    setCurrentPage,
    navigate,
    user,
    jobsData,
    isLoading,
    has_more_pages,
    total_pages,
    formatDate,
    handleApplyJob,
    setValueJobslisting,
    setShowPopup,
    valuejobslisting,
  } = Functions();
  return (
    <div className=" sm:h-screen w-screen flex flex-col bg-[#000000]">
      {/* Navbar */}
      <SearchbarCom />
      <div className="grid sm:grid-cols-7 lg:grid-cols-6 xs:pt-10 sm:pt-16 sm:px-2 lg:px-2 xl:px-3">
        {/* Left Sidebar */}
        <div className="sm:col-span-2 lg:col-span-1 xs:z-50">
          <SidenavbarCom />
        </div>

        {/* Center Content (Scrollable) */}
        <div className=" sm:col-span-5 h-[calc(100vh-4rem)]">
          <div className={` w-full xs:px-1 sm:pl-4 lg:pl-5 h-full pt-2 pb-1`}>
            <div className="flex flex-col relative w-full h-full bg-[#1A1A1A] xs:px-2 sm:px-3 lg:px-5 rounded-lg">
              <div className="flex items-center justify-start py-5 sm:py-10">
                <h1 className="text-white xs:text-xs sm:text-sm lg:text-4xl font-onestSemiBold">
                  Job List
                </h1>
              </div>
              <FavJobTable
                title={[
                  "Job Title",
                  "Jobs Type",
                  "Country",
                  "Province",
                  "City",
                  "Description",
                  "Benefits",
                  "Expiry Date",
                  "Salary",
                  "NO Of Positions",
                  "Actions",
                ]}
                // title={['Job Title', 'Jobs Type', 'Country', 'Province', 'City', 'Post Code', 'Description', 'Benefits', 'Job Shift', 'Gender', 'Expiry Date', 'Degree Level', 'Salary', 'NO Of Positions', 'Actions']}
                data={jobsData?.job_applies}
                setValueJobslisting={setValueJobslisting}
                setShowPopup={setShowPopup}
                loadingapplyapi={loadingapplyapi}
                handleApplyJob={handleApplyJob}
                isLoading={isLoading}
                formatDate={formatDate}
                requestTitle={"favourites Jobs"}
              />
              {isLoading && (
                <div className="pt-3 flex justify-center">
                  <Animatespin />
                </div>
              )}

              {/* Popup Modal */}
              <div
                className={`fixed top-0 right-0 z-50 w-full sm:w-9/12 lg:w-7/12 xl:w-1/3 bg-[#0F0F0F] xs:py-3 xs:px-2 sm:px-3 sm:py-4 lg:px-4 lg:py-5 h-full scroll-container ${showPopup ? "translate-x-0" : "translate-x-full"
                  } transition-transform duration-300 ease-in-out`}
              >
                <div className="flex justify-center items-start flex-col relative h-full">
                  <div
                    className={`group flex cursor-pointer justify-center items-center xs:px-1.5 sm:px-3 lg:px-5 xs:py-[1.5px] sm:py-1 bg-[#2A2A2A] xs:rounded-md sm:rounded-lg transition-transform duration-300 transform hover:scale-105`}
                    onClick={() => setShowPopup(false)}
                  >
                    <IoIosArrowRoundBack className="text-secondary sm:text-2xl transition-colors duration-300 group-hover:text-orangeCrayola" />
                    <p className="text-secondary font-onestRegular xs:text-xs sm:text-sm lg:text-sm transition-colors duration-300 group-hover:text-secondary">
                      Back
                    </p>
                  </div>
                  <div className="text-center w-full xs:pt-4 xs:pb-5 sm:pt-7 sm:pb-7 lg:pb-10">
                    <h2 className="text-secondary  font-unboundedBold uppercase xs:text-xs sm:text-lg lg:text-xl xl:text-2xl">
                      JOB DESCRIPTION
                    </h2>
                  </div>
                  <div className="w-full flex-1 overflow-y-auto dashboard-scrollbar sm:pr-2 pr-1">
                    <div className="flex justify-between xs:py-2 sm:py-3 lg:py-4">
                      <div>
                        <p className="xs:text-[10px] sm:text-sm lg:text-base font-onestRegular text-secondary lg:gap-x-4">
                          Job Title:
                          <span className="xs:ml-1 sm:ml-1.5 lg:ml-2 xl:ml-3 xs:!text-[8px] sm:text-xs lg:text-sm text-[#8A8A8A]">
                            {valuejobslisting?.job?.title}
                          </span>
                        </p>
                      </div>
                      <div>
                        <p className="xs:text-[10px] sm:text-sm lg:text-base font-onestRegular text-secondary">
                          Jobs Type:
                          <span className="xs:ml-1 sm:ml-1.5 lg:ml-2 xl:ml-3 xs:!text-[8px] sm:text-xs lg:text-sm text-[#8A8A8A]">
                            {valuejobslisting?.job?.job_types?.job_type}
                          </span>
                        </p>
                      </div>
                    </div>
                    <div className="flex justify-between xs:py-2 sm:py-3 lg:py-4">
                      <div>
                        <p className="xs:text-[10px] sm:text-sm lg:text-base font-onestRegular text-secondary">
                          Country:
                          <span className="xs:ml-1 sm:ml-1.5 lg:ml-2 xl:ml-3 xs:!text-[8px] sm:text-xs lg:text-sm text-[#8A8A8A]">
                            {valuejobslisting?.job?.country?.country}
                          </span>
                        </p>
                      </div>
                      <div>
                        <p className="xs:text-[10px] sm:text-sm lg:text-base font-onestRegular text-secondary">
                          Province:
                          <span className="xs:ml-1 sm:ml-1.5 lg:ml-2 xl:ml-3 xs:!text-[8px] sm:text-xs lg:text-sm text-[#8A8A8A]">
                            {valuejobslisting?.job?.state?.state}
                          </span>
                        </p>
                      </div>
                    </div>
                    <div className="flex justify-between xs:py-2 sm:py-3 lg:py-4">
                      <div>
                        <p className="xs:text-[10px] sm:text-sm lg:text-base font-onestRegular text-secondary">
                          City:
                          <span className="xs:ml-1 sm:ml-1.5 lg:ml-2 xl:ml-3 xs:!text-[8px] sm:text-xs lg:text-sm text-[#8A8A8A]">
                            {valuejobslisting?.job?.city?.city}
                          </span>
                        </p>
                      </div>
                      <div>
                        <p className="xs:text-[10px] sm:text-sm lg:text-base font-onestRegular text-secondary">
                          Post code:
                          <span className="xs:ml-1 sm:ml-1.5 lg:ml-2 xl:ml-3 xs:!text-[8px] sm:text-xs lg:text-sm text-[#8A8A8A]">
                            {valuejobslisting?.job?.postal_code}
                          </span>
                        </p>
                      </div>
                    </div>
                    <div className="xs:pb-2 sm:pb-3 lg:pb-4">
                      <div className="xs:pb-2 sm:pb-3 lg:pb-4">
                        <p className="xs:text-[10px] sm:text-sm lg:text-base font-onestRegular text-secondary">
                          Description
                        </p>
                      </div>
                      <div className="xs:max-h-[120px] sm:max-h-[150px] custom-scrollbar overflow-y-scroll">
                        <p
                          className="html-container font-onestRegular text-[#8A8A8A] xs:!text-[8px] sm:text-xs lg:text-sm"
                          dangerouslySetInnerHTML={{
                            __html: valuejobslisting?.job?.description,
                          }}
                        />
                      </div>
                    </div>
                    <div className="xs:pb-2 sm:pb-3 lg:pb-4">
                      <div className="xs:pb-2 sm:pb-3 lg:pb-4">
                        <p className="xs:text-[10px] sm:text-sm lg:text-base font-onestRegular text-secondary">
                          Benefits
                        </p>
                      </div>
                      <div className="xs:gap-x-2 xs:gap-y-2 sm:gap-x-3 sm:gap-y-3 flex items-center flex-wrap">
                        <div className="xs:max-h-[120px] bg-[#2A2A2A] xs:px-3 xs:py-1 sm:px-3 sm:py-1 xs:rounded-md sm:rounded-lg sm:max-h-[150px] custom-scrollbar overflow-y-scroll">
                          <p
                            className="html-container  text-secondary xs:text-xs sm:text-sm lg:text-base"
                            dangerouslySetInnerHTML={{
                              __html: valuejobslisting?.job?.benefits,
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="flex xs:py-2 sm:py-3 lg:py-4 justify-between">
                      <div>
                        <p className="xs:text-[10px] sm:text-sm lg:text-base font-onestRegular text-secondary lg:gap-x-4">
                          Job Shift:
                          <span className="xs:ml-1 sm:ml-1.5 lg:ml-2 xl:ml-3 xs:!text-[8px] sm:text-xs lg:text-sm text-[#8A8A8A]">
                            {valuejobslisting?.job?.job_shift?.job_shift}
                          </span>
                        </p>
                      </div>
                      <div>
                        <p className="xs:text-[10px] sm:text-sm lg:text-base font-onestRegular text-secondary">
                          Gender:
                          <span className="xs:ml-1 sm:ml-1.5 lg:ml-2 xl:ml-3 xs:!text-[8px] sm:text-xs lg:text-sm text-[#8A8A8A]">
                            {valuejobslisting?.job?.gender?.gender}
                          </span>
                        </p>
                      </div>
                    </div>
                    <div className="flex xs:py-2 sm:py-3 lg:py-4 justify-between">
                      <div>
                        <p className="xs:text-[10px] sm:text-sm lg:text-base font-onestRegular text-secondary lg:gap-x-4">
                          Expiry Date:
                          <span className="xs:ml-1 sm:ml-1.5 lg:ml-2 xl:ml-3 xs:!text-[8px] sm:text-xs lg:text-sm text-[#8A8A8A]">
                            {formatDate(valuejobslisting?.job?.expiry_date)}
                          </span>
                        </p>
                      </div>
                      <div>
                        <p className="xs:text-[10px] sm:text-sm lg:text-base font-onestRegular text-secondary">
                          Degree Level:
                          <span className="xs:ml-1 sm:ml-1.5 lg:ml-2 xl:ml-3 xs:!text-[8px] sm:text-xs lg:text-sm text-[#8A8A8A]">
                            {valuejobslisting?.job?.degree_level?.degree_level}
                          </span>
                        </p>
                      </div>
                    </div>
                    <div className="flex xs:py-2 sm:py-3 lg:py-4 justify-between">
                      {valuejobslisting?.job?.hide_salary ? (
                        ""
                      ) : (
                        <div>
                          <p className="xs:text-[10px] sm:text-sm lg:text-base font-onestRegular text-secondary lg:gap-x-4">
                            Salary:
                            <span className="xs:ml-1 sm:ml-1.5 lg:ml-2 xl:ml-3 xs:!text-[8px] sm:text-xs lg:text-sm text-[#8A8A8A]">
                              {valuejobslisting?.job?.salary_currency ?? ""}{" "}
                              {valuejobslisting?.job?.salary_from} -{" "}
                              {valuejobslisting?.job?.salary_to}
                            </span>
                          </p>
                        </div>
                      )}
                      <div>
                        <p className="xs:text-[10px] sm:text-sm lg:text-base font-onestRegular text-secondary">
                          No of Positions:
                          <span className="xs:ml-1 sm:ml-1.5 lg:ml-2 xl:ml-3 xs:!text-[8px] sm:text-xs lg:text-sm text-[#8A8A8A]">
                            {valuejobslisting?.job?.num_of_positions}
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className=" xs:text-[8px] sm:text-xs lg:text-sm xl:text-base flex xs:pt-1 sm:pt-2 lg:pt-3 w-full justify-center">
                    {
                      valuejobslisting?.is_job_applied ? "" :
                        <div className="xs:gap-1 sm:gap-2 lg:gap-3 flex justify-center items-center w-full">
                          <button
                            className={`bg-accepted xs:py-1 w-full flex justify-center xs:px-6 sm:px-8 sm:py-1 lg:px-10 lg:py-1 rounded-full 
                                                 ${loadingapplyapi ||
                                valuejobslisting?.is_job_applied
                                ? "opacity-50 cursor-not-allowed"
                                : "cursor-pointer"
                              }`}
                            onClick={() =>
                              handleApplyJob(
                                valuejobslisting?.job?.id,
                                user?.talent?.id
                              )
                            }
                            disabled={
                              loadingapplyapi || valuejobslisting?.is_job_applied
                            }
                            type="button"
                          >
                            {loadingapplyapi ? (
                              <div className="flex justify-center items-center">
                                <div className="animate-spin rounded-full border-t-2 border-b-2 group-hover:border-primary border-secondary w-6 h-6"></div>
                              </div>
                            ) : (
                              <p className="xs:text-[8px] sm:text-xs lg:text-sm xl:text-base font-onestRegular text-secondary">
                                Apply
                              </p>
                            )}
                          </button>
                        </div>
                    }
                  </div>
                </div>
              </div>
              <div className="pt-2.5 pb-5 sm:pt-5 sm:pb-10">
                {jobsData?.total_records > 10 && (
                  <div className="flex justify-end items-center">
                    <Pagination
                      setCurrentPage={setCurrentPage}
                      currentPage={currentPage}
                      total_pages={total_pages}
                      has_more_pages={has_more_pages}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
